import { IOperation } from './i-operation';
import { Connection } from '@3d-scene/model3d/connection';
import { BaseBridgeArticlePinsOperation } from './base-bridge-article-pins-operation';
import { ContainerService } from '@3d-scene/model3d/container.service';
import { BridgeArticleManager } from '@project/components/article/manager/bridge-article.manager';
import { ConnectionInfoService } from '@3d-scene/model3d/service/connection-info.service';

export class UndoBreakPinsOperation extends BaseBridgeArticlePinsOperation implements IOperation {

  constructor(connectionCubes: Connection[], bridgeManager: BridgeArticleManager, containerService: ContainerService, connectionInfoService: ConnectionInfoService) {
    super(connectionCubes, bridgeManager, containerService, connectionInfoService);
  }

  public async performRedo(): Promise<void> {
    this.breakPins();
  }

  public async performUndo(): Promise<void> {
    this.restorePins();
  }

  public getOperationDescription(): string {
    return '';
  }

  public getQualifiedClassName(): string {
    return 'UndoBreakPinsOperation';
  }
}
